import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/utils';

/** Standard page width + padding wrapper for content under the AppShell. */
export function ContentContainer({
  children,
  className,
  title,
}: {
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    // One gutter for every screen under the shell: 1400px centred, 16/24px
    // padding. The container deliberately adds no vertical rhythm of its own —
    // pages stack their own blocks with `space-y-*`, and a margin here would
    // double it. `mb-5` on the optional title matches PageHeader's rhythm.
    <div className={cn('mx-auto w-full max-w-full px-4 py-5 md:px-6 md:py-6', className)}>
      {title && <h1 className="mb-5 text-display-sm font-bold text-on-surface">{title}</h1>}
      {children}
    </div>
  );
}
